function actionText(action) {
  return [action?.key, action?.label, action?.name]
    .filter(Boolean)
    .join(' ')
    .trim()
    .toLowerCase();
}

export function getCrudPermissionKey(action) {
  const explicit = String(action?.permissionKey ?? '').trim().toLowerCase();
  if (['add', 'edit', 'delete'].includes(explicit)) return explicit;
  if (action?.danger) return 'delete';

  const text = actionText(action);
  if (/(^|[\s_-])edit([\s_-]|$)/.test(text)) return 'edit';
  if (/(^|[\s_-])(add|create)([\s_-]|$)/.test(text)) return 'add';
  return null;
}
